import { useParams } from 'react-router-dom'

import { Box, NotFound } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { GroupHeader } from 'modules/expenses/components/groups/GroupHeader'
import { useGroupDetail } from 'modules/expenses/hooks/useGroupDetail'
import { useMyExpenses } from 'modules/expenses/pages/my_expenses/MyExpensesContext'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import ExpensesList from './List'
import { usePageActions } from './usePageActions'

const MyGroupDetailPage = () => {
  const { groupId } = useParams()
  const { navigation } = useNavigation()
  const { featureAvailabilities } = useMyExpenses()

  // My Expenses doesn't support payroll reimbursement - use defaults
  // TODO: Remove when we will fully migrate to DataCollection
  const currentPayrollPeriodOpen = false

  const { group, loading: loadingGroup } = useGroupDetail({ id: String(groupId) })
  const { actions, Modals } = usePageActions({
    group,
    currentPayrollPeriodOpen,
    reimburseThroughPayrollEnabled: featureAvailabilities.reimburseThroughPayroll,
  })

  return (
    <>
      {group && <GroupHeader group={group} actions={actions} />}
      <ResponsivePage.Body showHeader={false} error={false} loading={loadingGroup} variant="full">
        <Modals />
        {group ? (
          <Box gap="s16">
            <ExpensesList
              group={group}
              back={{ href: navigation.myExpenses.groups.id.fullPath({ groupId: group.id }) }}
            />
          </Box>
        ) : (
          <NotFound
            title={i18n.t('errors.page_not_found.title')}
            description={i18n.t('errors.page_not_found.description')}
          />
        )}
      </ResponsivePage.Body>
    </>
  )
}

export default MyGroupDetailPage
